import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectableNavigationItem} from '../../../model/selectable-navigation-item';
import {Order} from '../../../model/order';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {KeyDirections} from '../../../shared/key-directions.enum';

@Component({
  selector: 'app-play-trailer-button',
  templateUrl: './play-trailer-button.component.html',
  styleUrls: ['./play-trailer-button.component.less']
})
export class PlayTrailerButtonComponent extends SelectableNavigationItem implements OnInit {

  @Input()
  omapiId: string;
  @Input()
  active: boolean;
  @Output()
  emitOnEnterPressed = new EventEmitter<Order>();
  @Output()
  emitOnBack = new EventEmitter<Object>();
  @Input()
  playingTrailer = false;

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.navigationService.registerNavigation(this, this.ownerComponent);
  }

  @Input()
  onEnter(): void {
    this.emitOnEnterPressed.emit();
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

  canNavigateToDirection(keyCode: number): boolean {
    if (this.playingTrailer) {
      return keyCode === KeyDirections.ESCAPE;
    }
    return true;
  }

  public get activeClass() {
    return this.active;
  }

}
